<!-- Created by henian.xu on 2019/11/24. -->

<template>
    <div :class="['high-meter',{'button-type':isButtonType}]">
        <div class="inner">
            <template v-if="!isButtonType && imageList && imageList.length">
                <ImageList
                    :data="imageList"
                    @delete="onDeleteItem"
                />
            </template>
            <div
                v-if="!isExceed"
                class="add"
                @click="()=>{onPicker()}"
            >
                <el-button
                    v-if="isButtonType"
                    size="small"
                    type="primary"
                >
                    {{ buttonLabel }}
                </el-button>
                <div
                    v-else
                    class="inner"
                >
                    <i class="el-icon-plus" />
                </div>
            </div>
        </div>
        <el-dialog
            title="高拍仪作业"
            width="50%"
            :visible.sync="dialog.visible"
            append-to-body
            center
            :show-close="false"
            :destroy-on-close="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <div
                style="min-height: 300px"
                v-loading="!bigPriDev && !bigSubDev"
                element-loading-text="请稍候..."
            >

                <el-row
                    v-if='bigPriDev && !bigSubDev'
                    v-show="bigPriDev"
                    class="device-preview-wrap"
                    :gutter="20"
                >
                    <el-col
                        class="item"
                        :span="12"
                    >
                        <div class="label">
                            主头
                        </div>
                        <img
                            :src="bigPriDev"
                            alt="主头设备预览"
                        >
                    </el-col>
                    <el-col
                        class="item"
                        :span="12"
                    >
                        <el-form
                            v-show="!isUploading"
                            label-width="8em"
                            size="mini"
                        >
                            <el-form-item label="设置尺寸:">
                                <el-select
                                    v-model="formModel.scanSize"
                                    @input="onScanSizeInput"
                                >
                                    <el-option
                                        v-for="item in state.scanSize"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id"
                                    />
                                </el-select>
                                <el-select
                                    class="ma-l"
                                    v-model="formModel.priResolution"
                                    @input="onPriResolutionInput"
                                >
                                    <el-option
                                        v-for="(item) in state.priResolution"
                                        :key="'PriDev'+item"
                                        :label="item"
                                        :value="item"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="出图格式:">
                                <el-select v-model="formModel.priModel">
                                    <el-option
                                        v-for="item in state.priModel"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    />
                                </el-select>
                                <el-checkbox
                                    class="ma-l"
                                    v-model="formModel.setdeskew"
                                    @input='onSetdeskewInput'
                                >纠偏裁边</el-checkbox>
                            </el-form-item>
                            <el-form-item>
                                <el-button
                                    type="primary"
                                    @click="()=>{onPriDevPhotograph()}"
                                >
                                    拍摄
                                </el-button>
                                <el-button
                                    class='ma-l'
                                    type="primary"
                                    @click="()=>{onShowProperty()}"
                                >
                                    属性设置
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-row
                    v-else
                    v-show="bigPriDev || bigSubDev"
                    class="device-preview-wrap"
                    :gutter="20"
                >
                    <el-col
                        v-if="bigPriDev"
                        class="item"
                        :span="bigSubDev?12:24"
                    >
                        <div class="label">
                            主头
                        </div>
                        <img
                            :src="bigPriDev"
                            alt="主头设备预览"
                        >
                        <el-form
                            v-show="!isUploading"
                            label-width="8em"
                            size="mini"
                        >
                            <el-form-item label="设置尺寸:">
                                <el-select
                                    v-model="formModel.scanSize"
                                    @input="onScanSizeInput"
                                >
                                    <el-option
                                        v-for="item in state.scanSize"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id"
                                    />
                                </el-select>
                                <el-select
                                    class="ma-l"
                                    v-model="formModel.priResolution"
                                    @input="onPriResolutionInput"
                                >
                                    <el-option
                                        v-for="(item) in state.priResolution"
                                        :key="'PriDev'+item"
                                        :label="item"
                                        :value="item"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="出图格式:">
                                <el-select v-model="formModel.priModel">
                                    <el-option
                                        v-for="item in state.priModel"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    />
                                </el-select>
                                <el-checkbox
                                    class="ma-l"
                                    v-model="formModel.setdeskew"
                                    @input='onSetdeskewInput'
                                >纠偏裁边</el-checkbox>
                            </el-form-item>
                            <el-form-item>
                                <el-button
                                    type="primary"
                                    @click="()=>{onPriDevPhotograph()}"
                                >
                                    拍摄
                                </el-button>
                                <el-button
                                    class='ma-l'
                                    type="primary"
                                    @click="()=>{onShowProperty()}"
                                >
                                    属性设置
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col
                        v-if="bigSubDev"
                        class="item"
                        :span="bigPriDev?12:24"
                    >
                        <div class="label">
                            副头
                        </div>
                        <img
                            :src="bigSubDev"
                            alt="副头设备预览"
                        >
                        <el-form
                            v-show="!isUploading"
                            label-width="8em"
                            size="mini"
                        >
                            <el-form-item label="出图格式:">
                                <el-select v-model="formModel.subModel">
                                    <el-option
                                        v-for="item in state.subModel"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    />
                                </el-select>
                                <el-select
                                    class="ma-l"
                                    v-model="formModel.subResolution"
                                >
                                    <el-option
                                        v-for="(item) in state.subResolution"
                                        :key="'SubDev'+item"
                                        :label="item"
                                        :value="item"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button
                                    type="primary"
                                    @click="()=>{onSubDevPhotograph()}"
                                >
                                    拍摄
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
            <el-upload
                v-show="false"
                ref="elUpload"
                class="upload-demo"
                v-bind='$attrs'
                :action="actionUrl"
                :headers="headers_"
                :file-list="fileList"
                :on-progress="onProgress"
                :on-success="onSuccess"
                :on-error="onError"
                :auto-upload="false"
            >
                <el-button
                    slot="trigger"
                    size="small"
                    type="primary"
                >
                    选取文件
                </el-button>
                <div
                    slot="tip"
                    class="el-upload__tip"
                >
                    只能上传jpg/png文件，且不超过500kb
                </div>
            </el-upload>
            <div class="photograph-history">
                <div
                    class="item"
                    v-for="(item,index) in state.photographHistory"
                    :key="index"
                    @click="onHistoryItem(item,index)"
                >
                    <i
                        v-if="item.selected"
                        class="icon el-icon-success"
                    />
                    <div
                        class="ctrl-wrap"
                        v-if="item.status==='uploading'||item.status==='error'"
                    >
                        <i
                            v-if="item.status==='error'"
                            class="error el-icon-warning"
                            @click.stop="onItemError(item)"
                        />
                        <el-progress
                            v-if="item.status==='uploading'"
                            type="circle"
                            :percentage="item.percentage|number(0,false)"
                            :width="80"
                        />
                    </div>
                    <img
                        class="img-obj"
                        :src="item.blob"
                        alt="tmp"
                    >
                </div>
            </div>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    @click="()=>{onComplete()}"
                    :disabled="!state.photographHistory.length"
                >
                    确 定
                </el-button>
                <el-button
                    :disabled="isUploading"
                    @click="()=>{onCancel()}"
                >
                    取 消
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter';

import {
    open,
    close,
    state,
    priPhotograph,
    subPhotograph,
    setPriScanSize,
    setPriResolution,
    setdeskew,
    showProperty,
} from './store';

export default {
    name: 'HighMeter',
    mixins: [emitter],
    inject: {
        elForm: {
            default: '',
        },
        elFormItem: {
            default: '',
        },
    },
    data() {
        return {
            dialog: {
                visible: false,
            },
            state,
            formModel: {
                scanSize: '原始尺寸',
                priModel: 'YUY2',
                priResolution: '2048 * 1536',
                subModel: 'MJPG',
                subResolution: '1920 * 1080',
                setdeskew: false,
            },
            fileList: [],
            isUploading: false,
            closeIng: false,
        };
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        action: {
            type: String,
            default: '',
            required: true,
        },
        type: {
            type: String,
            default: 'list',
        },
        buttonLabel: {
            type: String,
            default: '添加文件',
        },
        limit: {
            type: Number,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        headers: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', [...val]);
            },
        },
        imageList() {
            return this.model.map(item => item.address);
        },
        headers_() {
            const { headers } = this;
            return {
                // token: Utils.GlobalVar.appConfig.AXIOS_DEFAULT_CONFIG.headers.token,
                // token: this.$store.getters['Global/User/token'],
                ...headers,
            };
        },
        actionUrl() {
            const { action } = this;
            // const baseURL = Utils.GlobalVar.appConfig.AXIOS_DEFAULT_CONFIG.baseURL || '';
            // return baseURL + action;
            return action;
        },
        photographHistoryMap() {
            return state.photographHistory.reduce((pre, curr) => {
                pre[curr.id] = curr;
                return pre;
            }, {});
        },
        bigPriDev() {
            return state.bigPriDev;
        },
        bigSubDev() {
            return state.bigSubDev;
        },
        isDisabled() {
            return this.disabled || (this.elForm || {}).disabled;
        },
        isExceed() {
            const { limit, model } = this;
            return limit && model.length >= limit;
        },
        isButtonType() {
            return this.type === 'button';
        },
    },
    methods: {
        async onPicker() {
            if (this.isDisabled) return;
            try {
                await open();
            } catch (e) {
                this.$alert(e, '错误提示');
                return;
            }
            this.dialog.visible = true;
        },
        async onCancel() {
            if (this.closeIng) return;
            this.closeIng = true;
            await close();
            this.dialog.visible = false;
            this.closeIng = false;
        },
        onDeleteItem({ index }) {
            const model = [...this.model];
            model.splice(index, 1);
            this.model = model;
        },
        async onPriDevPhotograph() {
            await priPhotograph();
            // this.temImgSrc = res.base64;
        },
        async onSubDevPhotograph() {
            await subPhotograph();
        },
        onScanSizeInput(value) {
            setPriScanSize(value);
        },
        onPriResolutionInput(value) {
            setPriResolution(value);
        },
        onSetdeskewInput(value) {
            setdeskew(value);
        },
        onShowProperty() {
            showProperty();
        },
        onHistoryItem(item, index) {
            if (item.status === 'uploading') return;
            state.photographHistory.splice(index, 1, {
                ...item,
                selected: !item.selected,
            });
        },
        onProgress(event, file /* , fileList */) {
            const { name, percentage, status } = file;
            const currentFile = this.photographHistoryMap[name];
            if (!currentFile) return;
            currentFile.progress = percentage;
            currentFile.status = status;
        },
        onSuccess(response, file /* , fileList */) {
            const { data, success, msg } = response;
            const { name, status } = file;
            const currentFile = this.photographHistoryMap[name];
            if (!currentFile) return;
            currentFile.response = data;
            if (success) {
                currentFile.status = status;
            } else {
                currentFile.status = 'error';
                currentFile.error = msg;
            }
            this.setModel();
        },
        onError(err, file /* , fileList */) {
            const { name, status } = file;
            const currentFile = this.photographHistoryMap[name];
            if (!currentFile) return;
            currentFile.status = status;
            currentFile.error = err;
        },
        onItemError(item) {
            this.$alert(item.error, '错误提示', {
                confirmButtonText: '确定',
            });
        },
        setModel() {
            const { photographHistory } = state;
            const error = photographHistory.some(item => item.selected && item.status !== 'success');
            if (error) {
                this.isUploading = false;
                return;
            }

            const res = photographHistory.reduce((pre, cur) => {
                if (cur.selected && cur.status === 'success' && cur.response && cur.response.address) {
                    pre.push(cur.response);
                }
                return pre;
            }, []);
            this.model = [...this.model, ...res];
            this.isUploading = false;
            this.onCancel();
        },
        onComplete() {
            // debugger;
            const $elUpload = this.$refs.elUpload;
            if (!$elUpload || !$elUpload.$refs) return;
            const $uploadInner = $elUpload.$refs['upload-inner'];
            if (!$uploadInner) return;
            $elUpload.clearFiles();
            const fileList = state.photographHistory.reduce((pre, cur) => {
                if (!cur.selected || cur.status === 'success') return pre;
                pre.push(cur.file);
                return pre;
            }, []);

            const modelLen = this.model.length;
            const fileListLen = fileList.length;
            if (this.limit && fileListLen + modelLen > this.limit) {
                this.$alert(`上传文件超过${this.limit},请重新选择.`, '错误提示');
            } else if (fileListLen) {
                fileList.forEach(file => $uploadInner.uploadFiles([file]));
                this.$nextTick(() => {
                    $elUpload.submit();
                    this.isUploading = true;
                });
            }
        },
    },
    created() {},
};
</script>

<style lang="scss">
.high-meter {
    > .inner {
        > .image-list-wrap {
            display: inline-block;
            vertical-align: top;
        }
        > .add {
            display: inline-block;
            vertical-align: top;
            margin-left: $margin-small;
            width: 98px;
            > .inner {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 0;
                padding: 50% 0;
                border: 1px dashed $color-border;
                border-radius: 3px;
                font-size: 20px;
            }
        }
    }

    &.button-type {
        display: inline-block;
        vertical-align: middle;
    }
}
.device-preview-wrap {
    .item {
        .label {
            font-weight: bold;
        }
        img {
            width: 100%;
            height: auto;
        }
    }
}
.photograph-history {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: wrap;
    > .item {
        position: relative;
        background-color: $gray2;
        border-radius: $padding-small;
        padding: $padding-small;
        margin: $margin-small;
        > .icon {
            position: absolute;
            z-index: $z-index-2;
            top: $padding;
            right: $padding;
            color: $color-success;
            font-size: 120%;
        }
        > .ctrl-wrap {
            /*display: none;*/
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: $padding-small;
            right: $padding-small;
            bottom: $padding-small;
            left: $padding-small;
            background-color: rgba(0, 0, 0, 0.5);
            padding: $padding;
            > .error {
                color: $color-danger;
                font-size: 120%;
            }
            > .el-progress {
                > .el-progress__text {
                    color: #fff;
                }
            }
        }
        > .img-obj {
            display: block;
            width: 200px;
            height: 200px * 0.75;
            object-fit: cover;
        }
    }
}
</style>
